import { ChainAvatar } from '@Components/ConnectedChainCard';
import { FIELD_SERVICE_AVATAR_TEXT_COLOR, getFieldServiceInitials } from '../../FieldServices/assignFieldServiceColor';

interface Firm {
  id: string;
  name: string;
}

interface FirmAvatarStackProps {
  firms: Firm[];
  colorsById: Record<string, string>;
  maxVisible?: number;
}

const AVATAR_SIZE_CLASS = 'h-6 w-6 rounded-[5px] text-[10px] font-bold';

const FirmAvatarStack = ({ firms, colorsById, maxVisible = 4 }: FirmAvatarStackProps) => {
  if (firms.length === 0) return <span className="text-gray-400">—</span>;

  const visibleFirms = firms.slice(0, maxVisible);
  const overflowFirms = firms.slice(maxVisible);

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {visibleFirms.map((firm) => (
        <span key={firm.id} title={firm.name}>
          <ChainAvatar
            size="sm"
            className={AVATAR_SIZE_CLASS}
            initials={getFieldServiceInitials(firm.name)}
            color={colorsById[firm.id]}
            textColor={FIELD_SERVICE_AVATAR_TEXT_COLOR}
          />
        </span>
      ))}
      {overflowFirms.length > 0 && (
        <span title={overflowFirms.map((firm) => firm.name).join(', ')}>
          <ChainAvatar
            size="sm"
            className={AVATAR_SIZE_CLASS}
            initials={`+${overflowFirms.length}`}
            color="#E5E7EB"
            textColor="#475569"
          />
        </span>
      )}
    </div>
  );
};

export default FirmAvatarStack;
export type { Firm };
